import { ChatPanel } from "./ChatPanel";

export function CompanionWorkspace() {
  return (
    <div
      role="region"
      aria-label="Compliance Companion"
      className="h-full w-full overflow-hidden bg-white dark:bg-[#131320]"
    >
      <ChatPanel />
    </div>
  );
}
